import type { IntlShape } from 'react-intl';
import { extractConnectorErrorReason } from '~/backend/connector-api/connector-error';
import { enqueueSnackbar } from '~/utils/notifications';

/**
 * Tells the user that an image could not be downloaded, with the
 * connector's reason when `error` carries one.
 */
export function reportImageDownloadFailure(
    intl: IntlShape,
    error?: unknown
): void {
    const reason = extractConnectorErrorReason(error);
    enqueueSnackbar(
        reason
            ? intl.formatMessage(
                  { id: 'image.downloadFailedWithReason' },
                  { reason }
              )
            : intl.formatMessage({ id: 'image.downloadFailed' }),
        { variant: 'error' }
    );
}
